/* HR - The Three S's of Success, scroll-scrub engine.
   Loaded as an external asset (not an inline <script>) because this theme's
   section/content rendering pipeline re-inserts section markup in a way
   that does not execute inline <script> tags (a standard browser behavior
   for script elements set via innerHTML) - moving the logic to a normal
   asset file with a real HTTP request sidesteps that entirely.
   Scoped by class only (no id dependency), so it is safe even if this
   section is ever duplicated on a page. */
(function(){
  /* Mobile carousel (owner directive 2026-07-31, v3): under 920px the CSS
     hides .tssF__scrub and shows .tssM, a single fixed-height section holding
     a horizontally paged carousel. The SCROLLING ITSELF IS NATIVE
     (overflow-x + scroll-snap in CSS) -- this JS only does the two things CSS
     cannot: keep the dots in sync with the scroll position, and move the
     scroller when a dot or the next chevron is tapped. No drag handling, no
     per-frame transform, nothing that fights iOS momentum.

     Runs on both desktop and mobile (harmless no-op if .tssM isn't in the
     DOM), so it never depends on the heavy scrub engine being initialised. */
  function initMobileCarousel(root){
    var cars=[].slice.call(root.querySelectorAll('[data-tssm-car]'));
    cars.forEach(function(car){
      if(car.__tssmInit)return;
      car.__tssmInit=true;

      var track=car.querySelector('[data-tssm-track]'),
          dotsBox=car.querySelector('[data-tssm-dots]'),
          next=car.querySelector('[data-tssm-next]'),
          prev=car.querySelector('[data-tssm-prev]'),
          slides=track?[].slice.call(track.querySelectorAll('[data-tssm-slide]')):[];
      if(!track||!slides.length)return;

      var reduce=window.matchMedia('(prefers-reduced-motion:reduce)'),
          n=slides.length,cur=-1,dots=[],ticking=false;

      /* dots are built in JS so the count can never drift from the slide count */
      if(dotsBox){
        slides.forEach(function(sl,i){
          var b=document.createElement('button');
          b.type='button';
          b.className='tssM-dot-b';
          b.setAttribute('role','tab');
          b.setAttribute('aria-label','Go to slide '+(i+1)+' of '+n);
          b.addEventListener('click',function(){go(i);});
          dotsBox.appendChild(b);
          dots.push(b);
        });
      }

      function targetLeft(i){
        var sl=slides[i];
        /* centre-snap: the same geometry scroll-snap-align:center resolves to,
           so a programmatic jump lands exactly where a swipe would settle. */
        return sl.offsetLeft-track.offsetLeft-(track.clientWidth-sl.offsetWidth)/2;
      }

      function go(i){
        i=Math.max(0,Math.min(n-1,i));
        track.scrollTo({left:targetLeft(i),behavior:reduce.matches?'auto':'smooth'});
      }

      function nearest(){
        var mid=track.scrollLeft+track.clientWidth/2,best=0,bd=Infinity;
        for(var i=0;i<n;i++){
          var sl=slides[i],
              c=sl.offsetLeft-track.offsetLeft+sl.offsetWidth/2,
              d=Math.abs(c-mid);
          if(d<bd){bd=d;best=i;}
        }
        return best;
      }

      function sync(){
        var i=nearest();
        if(i===cur)return;
        cur=i;
        dots.forEach(function(d,k){
          var on=k===i;
          d.classList.toggle('is-on',on);
          d.setAttribute('aria-selected',on?'true':'false');
        });
        slides.forEach(function(sl,k){
          /* keep offscreen slides out of the tab order and the a11y tree so a
             swipe carousel does not read as one enormous run-on region */
          sl.setAttribute('aria-hidden',k===i?'false':'true');
        });
        if(next)next.classList.toggle('is-off',i>=n-1);
        /* OWNER FIX 2026-08-01: matching back-arrow -- off on slide 1, on for
           every slide after it, so the pair always shows exactly the
           directions that are actually available. */
        if(prev)prev.classList.toggle('is-off',i<=0);
      }

      /* Coalesce the burst of scroll events iOS fires during momentum into at
         most one read per frame. rAF is the right scheduler on a visible page
         (the dots land in the same frame the scroll paints), but it is frozen
         while the tab is backgrounded, so a timeout runs alongside it as a
         safety net -- whichever fires first clears the flag and the other
         becomes a no-op. Passive listener: never blocks the scroll thread. */
      function schedule(){
        if(ticking)return;
        ticking=true;
        var ran=false,run=function(){if(ran)return;ran=true;ticking=false;sync();};
        requestAnimationFrame(run);
        setTimeout(run,120);
      }
      track.addEventListener('scroll',schedule,{passive:true});

      if(next)next.addEventListener('click',function(){go(cur+1);});
      if(prev)prev.addEventListener('click',function(){go(cur-1);});

      /* keyboard parity for the focusable track */
      track.addEventListener('keydown',function(e){
        if(e.key==='ArrowRight'){e.preventDefault();go(cur+1);}
        else if(e.key==='ArrowLeft'){e.preventDefault();go(cur-1);}
      });

      /* Closing product moment (owner fix 2026-07-31): three real berries travel
         into the real box ONCE, the first time that slide is actually on screen.
         Never loops, never re-arms, and each berry drops its will-change hint the
         moment its own animation finishes, so nothing stays promoted after the
         ~800ms run. Reduced motion is handled in CSS (no travel, settled state).
         If IntersectionObserver is missing the class is simply applied on init. */
      var prod=car.querySelector('[data-tssm-prod]');
      if(prod){
        var berries=[].slice.call(prod.querySelectorAll('.tssM-prod-b'));
        var fired=false;
        var fire=function(){
          if(fired)return;
          fired=true;
          prod.classList.add('is-go');
          berries.forEach(function(b){
            b.addEventListener('animationend',function(){b.classList.add('is-done');},{once:true});
          });
        };
        if('IntersectionObserver' in window){
          /* two gates, because the track is its own scroll container: the
             carousel must be on screen in the PAGE, and the closing slide must
             be the one showing inside the TRACK. */
          var inner=null;
          var outer=new IntersectionObserver(function(entries){
            entries.forEach(function(en){
              if(!en.isIntersecting||inner)return;
              inner=new IntersectionObserver(function(es){
                es.forEach(function(e2){
                  if(e2.isIntersecting){fire();inner.disconnect();outer.disconnect();}
                });
              },{root:track,threshold:0.55});
              inner.observe(prod);
            });
          },{threshold:0.2});
          outer.observe(car);
        }else{
          fire();
        }
      }

      window.addEventListener('resize',function(){cur=-1;sync();},{passive:true});
      sync();
    });
  }

  /* Buy CTA -> real cart behaviour, shared by the desktop pouch-cta and the
     mobile card-layout CTA (both carry [data-tss-buy]). Runs unconditionally
     so it works regardless of which layout is visible at the current width. */
  function initBuyCta(root){
    var ctas=[].slice.call(root.querySelectorAll('[data-tss-buy]'));
    if(!ctas.length)return;

    function box(){return document.querySelector('[data-variant-sub8]');}
    function drawer(){return document.querySelector('cart-drawer');}

    function selection(){
      var b=box();
      if(!b)return null;
      var v8=b.getAttribute('data-variant-sub8')||'',
          v4=b.getAttribute('data-variant-sub4')||'',
          p8=b.getAttribute('data-plan-sub8')||'';
      var card=b.querySelector('.hrsb-card.is-selected'),
          state=card?(card.getAttribute('data-hrsb-card')||'sub8'):'sub8';
      var id=(state==='sub4')?(v4||v8):(v8||v4);
      if(!id)return null;
      return {id:String(id),plan:(state==='sub8'?String(p8||''):''),known:[String(v8),String(v4)]};
    }

    function openDrawer(payload,cta){
      var d=drawer();
      if(!d){window.location.href=(window.Shopify&&Shopify.routes&&Shopify.routes.root?Shopify.routes.root:'/')+'cart';return;}
      if(payload&&typeof d.renderContents==='function'){
        try{d.renderContents(payload);return;}catch(e){}
      }
      if(typeof d.open==='function')d.open(cta);
    }

    function sectionIds(){
      var d=drawer();
      try{
        if(d&&typeof d.getSectionsToRender==='function'){
          return d.getSectionsToRender().map(function(s){return s.section||s.id;}).join(',');
        }
      }catch(e){}
      return '';
    }

    ctas.forEach(function(cta){
      if(cta.__tssBuyInit)return;
      cta.__tssBuyInit=true;
      var busy=false;
      cta.addEventListener('click',function(e){
        var sel=selection();
        if(!sel)return; /* no buy box on the page -> let the link navigate */
        e.preventDefault();
        if(busy)return;
        busy=true;
        var lbl=cta.querySelector('.pouch-cta__t,.tssM-cta__t'),prev=lbl?lbl.textContent:null;
        var done=function(){busy=false;if(lbl&&prev!=null)lbl.textContent=prev;cta.removeAttribute('aria-busy');};

        fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root?Shopify.routes.root:'/')+'cart.js',
          {headers:{'Accept':'application/json'},credentials:'same-origin'})
          .then(function(r){return r.ok?r.json():null;})
          .then(function(c){
            var already=false;
            if(c&&Array.isArray(c.items)){
              already=c.items.some(function(it){
                return sel.known.indexOf(String(it.variant_id))>-1;
              });
            }
            if(already){ openDrawer(null,cta); done(); return; }
            if(lbl){lbl.textContent='Adding…';}
            cta.setAttribute('aria-busy','true');
            var body={items:[{id:sel.id,quantity:1}]};
            if(sel.plan)body.items[0].selling_plan=sel.plan;
            var secs=sectionIds();
            if(secs){body.sections=secs;body.sections_url=window.location.pathname;}
            return fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root?Shopify.routes.root:'/')+'cart/add.js',
              {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
               credentials:'same-origin',body:JSON.stringify(body)})
              .then(function(r){return r.json();})
              .then(function(res){
                openDrawer(res&&res.sections?res:null,cta);
                document.dispatchEvent(new CustomEvent('cart:refresh'));
                done();
              });
          })
          .catch(function(){ done(); openDrawer(null,cta); });
      });
    });
  }

  function initOne(root){
    if(root.__tssFInit)return;
    root.__tssFInit=true;

    initMobileCarousel(root);
    initBuyCta(root);

    /* PERF (owner directive 2026-07-31): the pinned scroll-scrub engine below
       is desktop-only content now (.tssF__scrub is display:none under 920px
       in CSS). Below that width the mobile card layout (.tssM) owns the
       section, so skip building the whole flyer/station/scroll-tick engine
       entirely rather than let it run for an invisible, zero-height track. */
    if(!window.matchMedia('(min-width:920px)').matches){
      return;
    }

    var scrub=root.querySelector('.tssF__scrub'),
        stage=root.querySelector('.tssF__stage'),
        tint =root.querySelector('.tssF__tint'),
        leafbg=root.querySelector('.leafbg'),
        duskbeat=root.querySelector('.duskbeat'),
        flow =root.querySelector('.tssF__flow'),
        berriesEl=root.querySelector('.berries'),
        leavesEl=root.querySelector('.leaves');
    if(!scrub||!stage||!tint||!flow||!berriesEl||!leavesEl)return;

    var stations=[].slice.call(flow.querySelectorAll('.station')),
        /* both berry layers, in document order: the 9-strong cast behind the
           text (.berries) then the closing three above the box (.berries--close),
           which keeps the element order aligned with the BERRIES track array */
        berryEls=[].slice.call(root.querySelectorAll('.berries .rb')),
        leafEls=[].slice.call(leavesEl.querySelectorAll('.lf'));
    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var BERRIES = [
      /* INTEGRATION FIX 2026-07-30: these four used to converge on x45-55 / y40-58
         at s1.15 and full alpha at p=0.10-0.11. applyStations() switches to the
         Sunlight station at p>=0.05, so the peak of the sweep landed ON TOP of
         the Sunlight headline, its three beats, the phone and the caption -- a
         wall of fruit over the copy at exactly the station the owner called
         cluttered (verified in a 1440x900 capture at p=0.10).

         The sweep is kept, but routed down the two OUTER EDGES instead of
         through the middle: the pair on the left travels the left edge, the
         pair on the right mirrors it, and no berry ever enters x22-78 while it
         is visible. They are fully faded by p=0.095, so the Sunlight station is
         reached with a clean frame. Still one deliberate group of four moving
         together, never a lone object. Transform and opacity only. */
      /* OWNER 2026-07-30: "the berries are too far away, why are they in the
         corners? I can't even see them. They need to be ON the section." The
         sweep now runs INSIDE the frame: x14-18 on the left flank and x82-86 on
         the right (still clear of the x22-78 copy band), bigger scales, full
         alpha held through most of the opening, fading as Sunlight arrives. */
      [
        {p:0.000, x:16, y:10,  r: -8, s:0.62, a:0.95},
        {p:0.035, x:13, y:36,  r:-14, s:1.05, a:1.00},
        {p:0.070, x:15, y:62,  r:-24, s:0.88, a:0.85},
        {p:0.100, x: 8, y:88,  r:-36, s:0.60, a:0.00},
        {p:1.000, x: 8, y:88,  r:-36, s:0.60, a:0.00}
      ],
      [
        {p:0.000, x:84, y:10,  r:  8, s:0.62, a:0.95},
        {p:0.035, x:87, y:36,  r: 14, s:1.05, a:1.00},
        {p:0.070, x:85, y:62,  r: 24, s:0.88, a:0.85},
        {p:0.100, x:92, y:88,  r: 36, s:0.60, a:0.00},
        {p:1.000, x:92, y:88,  r: 36, s:0.60, a:0.00}
      ],
      [
        {p:0.000, x:15, y:90,  r: -6, s:0.58, a:0.95},
        {p:0.040, x:13, y:64,  r:-16, s:1.00, a:1.00},
        {p:0.075, x:16, y:38,  r:-26, s:0.82, a:0.80},
        {p:0.103, x: 8, y:12,  r:-38, s:0.58, a:0.00},
        {p:1.000, x: 8, y:12,  r:-38, s:0.58, a:0.00}
      ],
      [
        {p:0.000, x:85, y:90,  r:  6, s:0.58, a:0.95},
        {p:0.040, x:87, y:64,  r: 16, s:1.00, a:1.00},
        {p:0.075, x:84, y:38,  r: 26, s:0.82, a:0.80},
        {p:0.103, x:92, y:12,  r: 38, s:0.58, a:0.00},
        {p:1.000, x:92, y:12,  r: 38, s:0.58, a:0.00}
      ],
      /* FLYER CUT 2026-07-30 (specialist 1): the five "letters of Success"
         berries that used to live here are gone, and so are the five leaves.
         Their paths were staggered far enough apart that only one was ever on
         screen at a time, which is what the owner was reacting to ("why is
         there just one tea leaf flying? such a weird-ass animation") -- and 10
         of the 17 flyers were being written to on every single frame while
         invisible. The cast is now the four corner sweeps above (one deliberate
         group across Open -> Sunlight) and the three closing berries below (one
         deliberate group into the box). Nothing flies alone, and the middle of
         the section is left calm for the copy. */

      /* --- CLOSING THREE: the buy-moment convergence -------------------
         Owner brief: "when I scroll down, the berries should go inside the
         pouch rather than just being a regular scroll." These three stay
         dormant until the close station, sweep in BIG from lower-left,
         lower-right and top, then travel toward the box/pouch art (x50,y60
         is the box's on-screen centre) shrinking and fading as they arrive.
         They sit at z-index 1, under the z-index 3 station layer, so they
         read as passing INTO / behind the box exactly as it reaches full
         presence. Pure transform + opacity, driven by the same scroll
         progress as every other flyer here. */
      /* Convergence target is x50 / y48 -- the on-screen centre of the box art
         in the buy station. Every path is INSIDE the box's own band (y roughly
         38-60svh) by the time it is visible, so the berries read as travelling
         into the box, never as loose fruit sitting on the caption or the CTA.
         All three are fully faded by p=1, so the resting frame is just the box,
         the line and the button. */
      /* TIMING FIX 2026-07-30: these three were previously keyed from p=0.88,
         but applyStations() switches to a station on round(p*10), so the buy
         station (index 10) does not arrive until p>=0.95. The whole
         convergence therefore played out over station 9 (the "You will
         probably never reach where this berry grows" line) and was already
         faded to nothing by the time the box appeared -- berries converging
         on empty cream, verified in a 390px capture at p=0.945. Retimed into
         the 0.950-1.000 window so every frame of the merge happens WITH the
         box on screen, landing on the box's measured on-screen centre
         (x51 / y49 at 390x844 and at 1440). */
      /* OWNER FIX 2026-07-30 — CONTINUITY. "Why do the berries disappear? The
         animation should always be there... after 190+ comes up that berry should
         multiply into two or three and keep animating, and then they all go into
         the box. Right now they pop up out of nowhere."
         Previously these three were dormant until p=0.95, so the whole stretch
         from the opening sweep (gone by p=0.10) to the buy frame had NO berries,
         and then three appeared from off-screen with no cause.
         They now emerge out of the "what one berry carries" station (p=0.80, the
         190+ beat), multiply one after another, travel the OUTER FLANKS through
         the close (never crossing the x22-78 copy band), and only turn inward to
         converge on the box across the last few percent. One unbroken chain from
         the berry that carries 190+ to the box you buy. */
      [
        {p:0.000, x:51, y:49,  r:  0, s:0.02, a:0.00},
        {p:0.780, x: 12,y: 92, r:-10, s:0.45, a:0.00},
        {p:0.815, x: 14,y: 74, r:-14, s:0.95, a:0.95},
        {p:0.880, x: 11,y: 56, r:-20, s:1.00, a:0.95},
        {p:0.935, x: 15,y: 42, r:-26, s:0.92, a:0.90},
        {p:0.968, x: 30,y: 46, r: -8, s:0.80, a:0.85},
        {p:0.990, x: 45,y: 48, r: 10, s:0.34, a:0.48},
        {p:1.000, x: 50,y: 49, r: 16, s:0.06, a:0.00}
      ],
      [
        {p:0.000, x:51, y:49,  r:  0, s:0.02, a:0.00},
        {p:0.800, x: 88,y: 92, r: 10, s:0.45, a:0.00},
        {p:0.835, x: 86,y: 74, r: 14, s:0.95, a:0.95},
        {p:0.895, x: 89,y: 56, r: 20, s:1.00, a:0.95},
        {p:0.940, x: 85,y: 42, r: 26, s:0.92, a:0.90},
        {p:0.970, x: 70,y: 46, r:  8, s:0.80, a:0.85},
        {p:0.992, x: 55,y: 48, r:-10, s:0.34, a:0.48},
        {p:1.000, x: 50,y: 49, r:-16, s:0.06, a:0.00}
      ],
      /* OWNER FIX 2026-07-30 (K): this "falls from top" berry used to ramp to
         a:0.92 while still at y:24 -- well above the box, sitting directly on
         top of the buy headline ("Stop searching. This is the one."), which is
         promoted to z:4 (above the text) for this station. Verified in a
         1440x900 capture at p=0.965: a near-opaque berry sat squarely over the
         headline. The headline occupies roughly y:20-28svh in this station
         (measured from the pinned frame), the box's own band starts at
         y:~30svh. Alpha is now held at 0 for the entire fall from off-screen
         down to y:30 -- both keyframes that bracket the headline band share
         a:0.00, so nothing is visible while it crosses that text -- and only
         ramps up once it is already inside the box's band. */
      /* The third berry is the "multiply" beat: it splits off a little after the
         first two are already travelling, so the group visibly grows from one to
         three between the 190+ station and the close. It holds the upper-left
         gutter (outside the copy band) and joins the convergence last. */
      [
        {p:0.000, x:51, y:49,  r:  0, s:0.02, a:0.00},
        {p:0.855, x: 17,y: 40, r:  6, s:0.38, a:0.00},
        {p:0.885, x: 15,y: 30, r: -4, s:0.82, a:0.90},
        {p:0.935, x: 19,y: 34, r:-12, s:0.86, a:0.88},
        {p:0.972, x: 36,y: 43, r: -6, s:0.70, a:0.80},
        {p:0.993, x: 47,y: 48, r:-14, s:0.30, a:0.42},
        {p:1.000, x: 50,y: 49, r:-18, s:0.06, a:0.00}
      ]
    ];

    /* The leaf cast was removed from the markup (the `.leaves` container is now
       empty), so there are no leaf elements to drive. The array stays only so
       the applyFlyers call site does not need a special case; with leafEls === []
       the pass over it costs nothing. */
    var LEAVES = [];

    var TINTS=[
      {top:'rgba(255,244,225,0)',    bot:'rgba(196,120,40,0.04)'},
      {top:'rgba(255,224,168,0.34)', bot:'rgba(228,150,60,0.14)'},
      {top:'rgba(150,96,120,0.14)',  bot:'rgba(60,30,52,0.22)' },
      {top:'rgba(40,26,20,0.55)',    bot:'rgba(14,9,7,0.72)'  },
      {top:'rgba(255,224,180,0.22)', bot:'rgba(196,120,40,0.16)'},
      {top:'rgba(255,232,190,0.32)', bot:'rgba(196,120,40,0.20)'},
      {top:'rgba(255,232,190,0.28)', bot:'rgba(196,120,40,0.16)'},
      {top:'rgba(255,240,215,0.24)', bot:'rgba(196,120,40,0.14)'},
      {top:'rgba(180,140,90,0.22)',  bot:'rgba(80,50,20,0.32)' },
      {top:'rgba(255,220,170,0.32)', bot:'rgba(196,90,30,0.26)' },
      {top:'rgba(255,236,200,0.30)', bot:'rgba(200,100,32,0.30)'}
    ];

    function lerp(a,b,t){return a+(b-a)*t}
    function ease(t){return t<0.5?2*t*t:1-Math.pow(-2*t+2,2)/2}

    function interpKF(kfs,p){
      if(p<=kfs[0].p)return kfs[0];
      if(p>=kfs[kfs.length-1].p)return kfs[kfs.length-1];
      for(var i=0;i<kfs.length-1;i++){
        var a=kfs[i],b=kfs[i+1];
        if(p>=a.p&&p<=b.p){
          var t=ease((p-a.p)/(b.p-a.p));
          return{
            x:lerp(a.x,b.x,t),
            y:lerp(a.y,b.y,t),
            r:lerp(a.r,b.r,t),
            s:lerp(a.s,b.s,t),
            a:lerp(a.a,b.a,t)
          };
        }
      }
      return kfs[kfs.length-1];
    }

    var N=stations.length,SEG=N-1;
    var lastIdx=-1,ticking=false,lastP=0;

    /* Viewport dims are cached and refreshed only on resize. The previous build
       emitted transforms as calc(<n>vw - 50%) / calc(<n>svh - 50%): every one of
       the 17 flyers then made the engine re-resolve viewport units and a
       percentage against its own border box on EVERY style recalc, every frame.
       Resolving to plain px here keeps the per-frame work to pure compositing,
       which is the difference the owner felt between the standalone file and
       the live theme page (the theme page has far more style-recalc pressure). */
    var VW=window.innerWidth,SVH=window.innerHeight;
    var svhProbe=null,berrySize=[],leafSize=[],scrubTop=0,scrubH=0;
    /* last-written alpha per flyer; seeds the applyFlyers skip test */
    var berryPrevA=berryEls.map(function(){return 1;}),
        leafPrevA=leafEls.map(function(){return 1;});
    /* ALL layout reads happen here and only here (init + resize), never inside
       the per-frame tick, so the scroll loop is write-only. */
    function measureViewport(){
      VW=window.innerWidth;
      if(!svhProbe){
        svhProbe=document.createElement('div');
        svhProbe.style.cssText='position:absolute;top:0;left:0;width:0;height:100svh;pointer-events:none;visibility:hidden';
        stage.appendChild(svhProbe);
      }
      SVH=svhProbe.offsetHeight||window.innerHeight;
      /* Cache the scrub track's document-space geometry here too. measure()
         used to call getBoundingClientRect() on it EVERY frame, which forces a
         style+layout flush inside the scroll tick and contradicted this file's
         own "the scroll loop is write-only" claim. Reading it once per resize
         and deriving progress from window.pageYOffset alone makes that true. */
      var sr=scrub.getBoundingClientRect();
      scrubTop=sr.top+(window.pageYOffset||document.documentElement.scrollTop||0);
      scrubH=sr.height;
      berrySize=berryEls.map(function(el){return [el.offsetWidth,el.offsetHeight];});
      leafSize=leafEls.map(function(el){return [el.offsetWidth,el.offsetHeight];});
    }

    /* prevA remembers the alpha each flyer was last written at, so a flyer that
       is invisible now AND was invisible last frame is skipped entirely -- no
       opacity write, no transform string built, no style invalidation. Most
       flyers are dormant for most of the track (the closing three do nothing at
       all until p=0.95), so this removes the large majority of the per-frame
       style writes. The `prevA[k] >= EPS` half of the test is what guarantees the
       final "fade to 0" frame is still written before a flyer goes quiet. */
    var EPS=0.004;
    function applyFlyers(defs,els,sizes,prog,prevA){
      for(var k=0;k<els.length;k++){
        var kf=interpKF(defs[k],prog);
        if(kf.a<EPS && prevA[k]<EPS) continue;
        var el=els[k],sz=sizes[k]||[0,0];
        prevA[k]=kf.a;
        el.style.opacity=kf.a.toFixed(3);
        el.style.transform=
          'translate3d('+(kf.x*VW/100-sz[0]/2).toFixed(2)+'px,'+(kf.y*SVH/100-sz[1]/2).toFixed(2)+'px,0) '+
          'rotate('+kf.r.toFixed(2)+'deg) scale('+kf.s.toFixed(3)+')';
      }
    }

    /* Two stacked tint layers, cross-faded on opacity. The colours are written
       to whichever layer is currently at opacity 0, so the (non-compositable)
       background change is never painted; only the opacity swap is, and that the
       compositor owns. The old build transitioned `background` on a full-bleed
       element, which repainted the whole viewport every frame for 700ms at each
       station change -- a hitch landing exactly on the crossfade. */
    var tintLayers=tint?[].slice.call(tint.querySelectorAll('.tint-l')):[],
        tintOn=0;
    function mixTint(i){
      var use=TINTS[Math.max(0,Math.min(TINTS.length-1,i))];
      if(tintLayers.length===2){
        var nextI=tintOn^1,next=tintLayers[nextI];
        next.style.setProperty('--tt',use.top);
        next.style.setProperty('--tb',use.bot);
        next.classList.add('on');
        tintLayers[tintOn].classList.remove('on');
        tintOn=nextI;
      }else if(tint){
        tint.style.setProperty('--tint-top',use.top);
        tint.style.setProperty('--tint-bot',use.bot);
      }
      /* OWNER 2026-07-30: the Sleep intro read as bare text on an empty
         widescreen. The leaf field now has real presence on that beat (0.55)
         while staying a quieter texture behind the tea beat (0.34). */
      if(leafbg) leafbg.style.opacity=(i===2)?'0.55':(i===4)?'0.34':'0';
      if(duskbeat) duskbeat.style.opacity=(i===3)?'0.90':'0';
    }

    function applyStations(prog){
      var pos=prog*SEG,i=Math.round(pos);
      if(i<0)i=0;if(i>=N)i=N-1;
      if(i!==lastIdx){
        stations.forEach(function(st,idx){st.classList.toggle('is-in',idx===i)});
        root.setAttribute('data-station',String(i));
        mixTint(i);
        lastIdx=i;
      }
    }

    /* End-hold, as a fraction of one screen. The track was cut from 1240svh to
       600svh (see hr-three-s-v2.liquid), so the hold was cut in the same
       proportion -- 0.8svh of hold on a 1140svh pin is the same "settle" beat as
       0.45svh on a 500svh pin, and leaving it at 0.8 would have spent 17% of the
       new, much shorter track parked on the finished frame. */
    var HOLD=0.45;
    function measure(){
      /* svh-based and toolbar-independent: subtract the MEASURED stage height
         (SVH, the 100svh probe = the sticky element's own height), never
         window.innerHeight, so p=1 lands at the physical sticky release
         identically on desktop, mobile and 390 regardless of the iOS URL bar.
         An end-hold reserves the last stretch of pin so the buy frame lands and
         SETTLES before the section unpins. Zero layout reads: pure scroll math
         off the cached geometry. */
      var pinDist  = scrubH - SVH;        /* physical sticky travel = 500svh */
      var holdPx   = SVH * HOLD;          /* ~45svh settle-hold on the finished frame */
      var animate  = pinDist - holdPx;    /* progress 0->1 spans this, then holds at 1 through the hold */
      var y        = (window.pageYOffset||document.documentElement.scrollTop||0);
      var scrolled = Math.min(Math.max(y - scrubTop, 0), pinDist);
      return animate>0 ? Math.min(scrolled/animate, 1) : 0;
    }
    function tick(){
      ticking=false;
      var p=measure();
      lastP=p;
      applyFlyers(BERRIES,berryEls,berrySize,p,berryPrevA);
      applyFlyers(LEAVES,leafEls,leafSize,p,leafPrevA);
      applyStations(p);
      /* NOTE: the section root deliberately no longer carries a per-frame `--p`
         custom property. Custom properties inherit, so writing one on .tssF
         invalidated the computed style of every descendant (several hundred
         nodes) on every frame. Measured at 1440x900 across a 300-frame scroll it
         cost 4,431ms of style recalculation, 49% of the section's total. Its one
         consumer was the .glass blob's rotate/scale, which is now static. If any
         future effect needs scroll progress in CSS, put the variable on the ONE
         element that reads it, never on the section root. */
    }
    /* Off-screen scrolls do no work at all: the section is ~600svh tall, but
       the rest of this product page is long too, and the old build ran the full
       flyer write pass on every scroll frame of the WHOLE page. */
    var inView=true;
    function onScroll(){
      if(reduce||!inView)return;
      if(!ticking){ticking=true;requestAnimationFrame(tick);}
    }
    var resizeT=null;
    function onResize(){
      clearTimeout(resizeT);
      resizeT=setTimeout(function(){measureViewport();tick();},120);
    }

    if(reduce){
      stations.forEach(function(s){s.classList.add('is-in')});
      return;
    }
    requestAnimationFrame(function(){
      measureViewport();
      applyFlyers(BERRIES,berryEls,berrySize,0,berryPrevA);
      applyFlyers(LEAVES,leafEls,leafSize,0,leafPrevA);
      applyStations(0);
      stations[0].classList.add('is-in');
    });
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',onResize);

    /* Gate both the scroll pass and the 12 always-running berry float
       animations on visibility. `is-live` is what turns the float on (see the
       .rb.f rule), so while the section is off-screen the compositor has zero
       running animations from it. */
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        inView=entries[0].isIntersecting;
        root.classList.toggle('is-live',inView);
        /* Re-measure on entry: scrubTop is cached (see measureViewport) and
           anything that reflows the long product page ABOVE this section
           between init and arrival -- lazy images, late fonts, an app embed --
           would otherwise leave it stale. Entering the section is the exact
           moment it is both cheap and necessary to refresh. */
        if(inView){measureViewport();tick();}
      },{rootMargin:'200px 0px'}).observe(scrub);
    }else{
      root.classList.add('is-live');
    }

    root.__tssFDebug={progress:function(){return lastP;},go:function(p){
      /* invert the new measure() so go(p) lands exactly at progress p (0..1),
         using the same end-hold; go(1) sits at the start of the settle-hold
         where the buy frame is fully composed and pinned. */
      var pinDist=scrubH-SVH, animate=pinDist-SVH*HOLD;
      var y=scrubTop+Math.max(0,Math.min(p,1))*animate;
      window.scrollTo({top:y,behavior:'auto'});
      tick();
    }};
  }

  function initAll(){
    [].slice.call(document.querySelectorAll('.tssF')).forEach(initOne);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  /* defensive: also (re)scan shortly after load in case the section's DOM
     is attached slightly after DOMContentLoaded by other page scripts */
  window.addEventListener('load', initAll);
  setTimeout(initAll, 800);
})();
